<h1 class="text-center" [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.ausstieg.headline' | translate"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-3">
    <app-advisor-image *ngIf="textkeyPrefix != 'wpcheck'" path="/moc/moc-ausstieg.svg"></app-advisor-image>
    <app-advisor-image *ngIf="textkeyPrefix == 'wpcheck'" path="/wpc/wpc-ausstieg.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-9 large-8">
    <p [innerHTML]="(textkeyPrefix + '.verbrauchsanalyse.ausstieg') | translate"></p>
    <div class="callout" [innerHTML]="(textkeyPrefix + '.verbrauchsanalyse.ausstieg.' + case) | translate"></div>
  </div>
</div>

<app-step-buttons [previousLink]="lastStep" [nextLink]="null" [nextSubmit]="false" mediumWidthRight="9" mediumOffset="3" leftAlignSize="medium" largeOffset="3" largeWidthRight="8" nextText="moderat.verbrauchsanalyse.start.next"></app-step-buttons>

